import { DateInputRange, formatBalance } from '@ui/src';
import ProfitByCustomerItem from './parts/profit-by-customer-item';
import { PfitByCustomerTypes } from './types';

import cn from './styles.module.css';

const ProfitByCustomer = ({
  profitByCustomer,
  baseCurrency,
  currenciesList,
  profitByCustomerDates,
  setProfitByCustomerDate,
  onChangeProfitDates,
  onResetProfitDates,
}: PfitByCustomerTypes): React.JSX.Element => {
  const currency = currenciesList?.find((item) => item.id === baseCurrency?.id);

  return (
    <>
      <div className={cn.profitDatepicker}>
        <DateInputRange
          placeholder="Select Date"
          className={cn.profitByCustomerRangePicker}
          values={profitByCustomerDates.map((date) => date.toISOString())}
          onChangeRange={(dates) => {
            setProfitByCustomerDate(dates);
            onChangeProfitDates(dates);
          }}
          onReset={() => {
            setProfitByCustomerDate([]);
            onResetProfitDates();
          }}
        />
      </div>
      <div className={cn.profitByCustomerTop}>
        <ProfitByCustomerItem
          title="Fees received"
          value={`${baseCurrency?.name} ${formatBalance(
            profitByCustomer?.feesReceived || 0,
            currency,
          )}`}
        />
        <ProfitByCustomerItem
          title="Total account turnover (base currency)"
          value={`${baseCurrency?.name} ${formatBalance(
            profitByCustomer?.turnover || 0,
            currency,
          )}`}
        />
        <ProfitByCustomerItem
          title="Profit from customer turnover"
          value={`${profitByCustomer?.profitPercent}%`}
          black
        />
      </div>
    </>
  );
};

export default ProfitByCustomer;
